import { useEffect } from 'react';
import Lenis from 'lenis';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useAnimation } from '../providers/AnimationProvider.jsx';

/**
 * Instantiates Lenis and registers it with AnimationProvider's global ticker.
 * ScrollTrigger is notified on every Lenis scroll event so scrub animations
 * stay in sync with the smoothed scroll position.
 *
 * Pass enabled=false on pages that handle their own scroll (home scroll-snap,
 * store fixed overlay) to skip Lenis entirely while keeping the RAF running.
 */
export function useSmoothScroll(enabled = true) {
  const { registerLenis, unregisterLenis } = useAnimation();

  useEffect(() => {
    if (!enabled) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const lenis = new Lenis({
      lerp: 0.08,
      smoothWheel: true,
      syncTouch: false,   // let mobile use native momentum
    });

    // Keep GSAP ScrollTrigger scrub positions aligned with Lenis
    lenis.on('scroll', ScrollTrigger.update);

    registerLenis(lenis);

    return () => {
      unregisterLenis();
      lenis.destroy();
    };
  }, [enabled, registerLenis, unregisterLenis]);
}
